import { useMemo } from 'react';
import { useParams } from 'quartz-routing/react-router';
export function useParsedSearchResultsPathParams() {
  const {
    categorySlug,
    page,
    subcategorySlug,
    subcategory2Slug,
    teamSlug
  } = useParams();
  return useMemo(() => {
    const result = {};
    if (categorySlug) {
      result.categorySlug = categorySlug;
    }
    if (subcategorySlug) {
      result.subcategorySlug = subcategorySlug;
    }
    if (subcategory2Slug) {
      result.subcategory2Slug = subcategory2Slug;
    }
    if (teamSlug) {
      result.teamSlug = teamSlug;
    }
    // Parse the page parameter and validate it's a valid positive integer greater than 1.
    // - Page 1 should use the root path (e.g. /apps/all)
    // - Paginated paths should only be used for subsequent pages (e.g. /apps/all/page/2)
    // - If the page parameter is not a valid positive integer greater than 1, it should be ignored.
    if (page) {
      const pageNumber = parseInt(page, 10);
      if (!isNaN(pageNumber) && pageNumber > 1) {
        result.page = pageNumber;
      }
    }
    return result;
  }, [categorySlug, page, subcategorySlug, subcategory2Slug, teamSlug]);
}